export default[
  {
    path: '/lalisai',
    name: 'lalisai',
    // meta: {
    //   title: '凝聚她力量·启航新征程',
    //   isBind: true, // 是否绑定
    //   keepAlive: false
    // },
    component: resolve => {
      require([ '@/views/lalisai/main' ], resolve)
    },
    children: [
      {
        path: '/lalisai/index',
        name: 'lalisaiIndex',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/index' ], resolve)
        }
      },
      {
        path: '/lalisai/index2',
        name: 'lalisaiIndex2',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/index2' ], resolve)
        }
      },
      {
        path: '/lalisai/rule',
        name: 'lalisaiRule',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/rule' ], resolve)
        }
      },
      {
        path: '/lalisai/team',
        name: 'lalisaiTeam',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/team' ], resolve)
        }
      },
      {
        path: '/lalisai/list/:partyid',
        name: 'lalisaiList',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/list' ], resolve)
        }
      },
      {
        path: '/lalisai/lottery/:partyid',
        name: 'lalisaiLottery',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/lottery' ], resolve)
        }
      },
      {
        path: '/lalisai/invite',
        name: 'lalisaiInvite',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/invite' ], resolve)
        }
      },
      {
        path: '/lalisai/infor',
        name: 'lalisaiInfor',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/fillin' ], resolve)
        }
      },
      {
        path: '/lalisai/detail',
        name: 'lalisaiDetail',
        meta: {
          title: '凝聚她力量·启航新征程',
          isBind: true, // 是否绑定
          keepAlive: false
        },
        component: resolve => {
          require([ '@/views/lalisai/detail' ], resolve)
        }
      }
    ]
  }
]
